import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { CompanyProvider, useCompany } from "./contexts/CompanyContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";

import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import DashboardPage from "./pages/DashboardPage";
import ShiftPage from "./pages/ShiftPage";
import CustomersPage from "./pages/CustomersPage";
import MyCompanyPage from "./pages/MyCompanyPage";
import EmployeesPage from "./pages/EmployeesPage";
import AdminPermissionsPage from "./pages/AdminPermissionsPage";
import AdminLogPage from "./pages/AdminLogPage";
import ProjectsPage from "./pages/ProjectsPage";
import ProjectGroupsPage from "./pages/ProjectGroupsPage";
import ProjectOverviewPage from "./pages/ProjectOverviewPage";
import BusinessPage from "./pages/BusinessPage";
import MyCompaniesPage from "./pages/MyCompaniesPage";
import NoticeboardPage from "./pages/NoticeboardPage";
import PayrollPage from "./pages/PayrollPage";
import ReportsPage from "./pages/ReportsPage";
import TimestampPage from "./pages/TimestampPage";
// import ApplicationsPage from "./pages/ApplicationsPage"; // BORTTAGEN - används inte längre
import OvertimeRequestsPage from "./pages/OvertimeRequestsPage";
import AbsenceRequestsPage from "./pages/AbsenceRequestsPage";
import CreateCompanyPage from "./pages/CreateCompanyPage";

import ExportPayrollPage from "./pages/ExportPayrollPage";
import OBOverview from "./pages/OBOverview";
import OvertimeOverview from "./pages/OvertimeOverview";
import AbsenceOverview from "./pages/AbsenceOverview";
// import OvertimeAdmin from "./pages/OvertimeAdmin"; // BORTTAGEN - behövs inte
import Rules from "./pages/rules";

// Skyddad layout som kräver admin-behörighet
function ProtectedLayout({ children }) {
  const { activeCompany } = useCompany();
  return (
    <ProtectedRoute requireAdmin={true}>
      <Layout key={activeCompany?.companyAccountUid}>{children}</Layout>
    </ProtectedRoute>
  );
}

// Komponent för sidor som kräver admin-behörighet
function ProtectedPage({ children }) {
  return <ProtectedLayout>{children}</ProtectedLayout>;
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CompanyProvider>
          <Routes>
            {/* Publika routes - ingen inloggning krävs */}
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/create-company" element={<CreateCompanyPage />} />

            <Route path="/super-admin/permissions" element={<ProtectedPage><AdminPermissionsPage /></ProtectedPage>} />
            <Route path="/super-admin/log" element={<ProtectedPage><AdminLogPage /></ProtectedPage>} />
            <Route path="/super-admin/my-companies" element={<ProtectedPage><MyCompaniesPage /></ProtectedPage>} />

            <Route path="/noticeboard" element={<ProtectedPage><NoticeboardPage /></ProtectedPage>} />

            {/* Huvudroute - redirect till dashboard */}
            <Route path="/" element={<Navigate to="/dashboard" replace />} />

            {/* Skyddade routes - kräver admin eller super-admin behörighet */}
            <Route
              path="/dashboard"
              element={
                <ProtectedPage>
                  <DashboardPage />
                </ProtectedPage>
              }
            />

            <Route
              path="/shifts"
              element={
                <ProtectedPage>
                  <ShiftPage />
                </ProtectedPage>
              }
            />

            {/* BORTTAGEN - ApplicationsPage används inte längre
            <Route
              path="/applications"
              element={
                <ProtectedPage>
                  <ApplicationsPage />
                </ProtectedPage>
              }
            />
            */}

            {/* BORTTAGEN - OvertimeAdmin behövs inte
            <Route
              path="/overtime-admin"
              element={
                <ProtectedPage>
                  <OvertimeAdmin />
                </ProtectedPage>
              }
            />
            */}

            <Route
              path="/overtime-requests"
              element={
                <ProtectedPage>
                  <OvertimeRequestsPage />
                </ProtectedPage>
              }
            />

            <Route
              path="/absence-requests"
              element={
                <ProtectedPage>
                  <AbsenceRequestsPage />
                </ProtectedPage>
              }
            />

            <Route
              path="/my-company"
              element={<ProtectedPage><MyCompanyPage /></ProtectedPage>}
            />

            <Route
              path="/customers"
              element={
                <ProtectedPage>
                  <CustomersPage />
                </ProtectedPage>
              }
            />

            <Route
              path="/employees"
              element={
                <ProtectedPage>
                  <EmployeesPage />
                </ProtectedPage>
              }
            />

            <Route
              path="/projects"
              element={
                <ProtectedPage>
                  <ProjectsPage />
                </ProtectedPage>
              }
            />

            <Route
              path="/project-groups"
              element={
                <ProtectedPage>
                  <ProjectGroupsPage />
                </ProtectedPage>
              }
            />

            <Route
              path="/project-overview"
              element={
                <ProtectedPage>
                  <ProjectOverviewPage />
                </ProtectedPage>
              }
            />

            <Route
              path="/reports"
              element={
                <ProtectedPage>
                  <ReportsPage />
                </ProtectedPage>
              }
            />

            <Route
              path="/payroll"
              element={
                <ProtectedPage>
                  <PayrollPage />
                </ProtectedPage>
              }
            />

            <Route
              path="/ob-overview"
              element={
                <ProtectedPage>
                  <OBOverview />
                </ProtectedPage>
              }
            />

            <Route
              path="/overtime-overview"
              element={
                <ProtectedPage>
                  <OvertimeOverview />
                </ProtectedPage>
              }
            />

            <Route
              path="/absence-overview"
              element={
                <ProtectedPage>
                  <AbsenceOverview />
                </ProtectedPage>
              }
            />

            <Route
              path="/business"
              element={
                <ProtectedPage>
                  <BusinessPage />
                </ProtectedPage>
              }
            />

            <Route
              path="/export-payroll"
              element={
                <ProtectedPage>
                  <ExportPayrollPage />
                </ProtectedPage>
              }
            />

            {/* REGLER */}
            <Route
              path="/rules"
              element={
                <ProtectedPage>
                  <Rules />
                </ProtectedPage>
              }
            />

            {/* TIDSTÄMPLING */}
            <Route
              path="/timestamp"
              element={
                <ProtectedPage>
                  <TimestampPage />
                </ProtectedPage>
              }
            />

            {/* Catch-all route - redirect till dashboard */}
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </CompanyProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
